/* eslint-disable */
import React,{useState} from 'react';
import 'contents/assets/scss/page/mypage.scss';
import Paging from '../../component/Inc/Paging';
import Upload from '../../component/Inc/Upload';
import BtnLike from "../../component/Inc/BtnLike";//좋아요 버튼
function ManageWeeklyReport() {
  const [modalOpen, setModalOpen] = useState(false);
  const [tabIdx, setTabIdx] = useState(0);

  return (
    <main className="com_container com_work_report">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className='com_pg_tit icon menu9_6'>주간 업무보고</h2>
          <button onClick={() => setModalOpen(true)} className="com_btn orange s btn_plus">주간 업무보고 등록</button>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className='com_board_list__top'>
              <section className="com_board_search">
                <div className="com_btn_wrap">
                  <button className="com_btn line gray s active">오늘</button>
                  <button className="com_btn line gray s">1개월</button>
                  <button className="com_btn line gray s">3개월</button>
                </div>
                <div className="date_wrap">
                  <input
                    type="date"
                    className="com_datepicker"
                    placeholder="2022. 01. 01"
                  />
                  <span className="divider"> ~ </span>
                  <input
                    type="date"
                    className="com_datepicker"
                    placeholder="2022. 01. 01"
                  />
                  <button className="com_btn gray s">조회</button>
                </div>
              </section>
              <section className='com_board_search'>
                <article className='search'>
                  <input type="search" placeholder='검색할 내용을 입력해 주세요.' className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <table className='com_board_list'>
              <colgroup>
                <col width="14%"/><col width="14%"/>
                <col /><col width="12%"/>
                <col width="13%"/><col width="13%"/>
              </colgroup>
              <thead>
                <tr>
                  <th>등록일</th>
                  <th>등록 부서</th>
                  <th>제목</th>
                  <th>파일</th>
                  <th>등록자</th>
                  <th>조회수</th>
                </tr>
              </thead>
              <tbody>
                {[1,2,3,4,5,6,7,8,9,10].map((i,idx) => {
                  return (
                    <tr key={idx}>
                      <td className='td_date'>2022.08.25</td>
                      <td>인사총무</td>
                      <td className='td_left'>인사팀 주간 업무보고 입니다.</td>
                      <td><button className="btn_link blue">다운로드</button></td>
                      <td>홍길동103</td>
                      <td>34</td>
                    </tr>
                  )
                })}

                <tr className='selected'>
                  <td className='td_date'>2022.08.25</td>
                  <td>인사총무</td>
                  <td className='td_left'>인사팀 주간 업무보고 입니다.</td>
                  <td><button className="btn_link blue">다운로드</button></td>
                  <td>홍길동103</td>
                  <td>34</td>
                </tr>
              </tbody>
            </table>
            <Paging />
          </section>
          {/* 상세보기 */}
          <section className="box">
            <div className="detail_tit dot">상세보기</div>
            <div className="com_info">
              <p className="name">홍길동104</p>
              <span className="dot" />
              <p className="date">2023.05.20 11:30</p>
              <div className="count"><p>조회 <span className="cnt">321</span></p></div>
            </div>
            <div className="com_input_wrap">
              <div className="sec_input select_box">
                <div className="com_btn_wrap">
                  <BtnLike/>
                  <button className="btn_edit"></button>
                  <button className="btn_delete"></button>
                </div>
              </div>
              <div className="sec_input">
                <input type="text" className="input" placeholder='제목 입력' />
              </div>
              <div className="editor">
                인사총무팀에서 공유 드립니다.<br /><br />

                물품 청구서 양식입니다.<br />
                감사합니다.
              </div>
              <div className="com_input_upload">
                <Upload title="파일 찾기" className="com_btn gray xs wl"/>
                <p className="file">
                  <span className="txt">File name.pdf</span>
                  <button type="button" className="btn_del_file" onClick={() => {}}></button>
                </p>
              </div>
							 <hr className="com_divider"/>
							 <div className="com_btn_wrap center bottom">
                  <button
                    className="com_btn orange xs wl"
                  >등록
                  </button>
                </div>
            </div>
          </section>
        </section>
      </div>
    </main>
  );
}

export default ManageWeeklyReport;
